import { render, staticRenderFns } from "./SettingsApaleo.vue?vue&type=template&id=1a22f182&scoped=true&"
import script from "./SettingsApaleo.vue?vue&type=script&lang=ts&"
export * from "./SettingsApaleo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22f182",
  null
  
)

export default component.exports